import { adminAPI } from '../../../axiosInstance';


const getAllAdmin = async () => {
  const response = await adminAPI.get(`/admins/all`);
  return response.data;
};

const deleteAdmin = async (data: any) => {
  const response = await adminAPI.put(`/admins/delete/${data}/super-admin`);
  return response.data;
}

// const getAllOffer = async () => {
//   const response = await webAPI.get('/offers');
//   return response.data;
// };

// const addOffer = async (data: any) => {
//   console.log('data2333', data)
//   const response = await webAPI.post('/offers/create', data, {
//     headers: {
//       'Content-Type': 'application/json',
//     },
//   });
//   return response.data;
// };

// const deleteOffer = async (data: any) => {
//   const response = await webAPI.delete(`/offers/delete/${data}`);
//   return response.data;
// };

export { getAllAdmin, deleteAdmin };
